export const environment = {
	webBase: 'https://bomaid.vivascore.ai',
	appEnvironmentBaseUrl: 'https://api.alulahealth.com/health/environment',
	deeplinkURL: 'bomaid://',

	dislaimerUrl: 'https://www.bomaid.co.bw/thrive-disclaimer-data-use-accuracy-and-liability-notice',
	privacyPolicy: 'https://www.bomaid.co.bw/privacy-notice',
	termsOfUse: 'https://www.bomaid.co.bw/thrive-terms-and-conditions',
	faqUrl: 'https://www.bomaid.co.bw/thrive-frequently-asked-questions',
	useHelpCenter: false,
	aboutUsUrl: '#',
	contactUsUrl: '#',
	welcomeBackground: '/assets/v2/welcome/background-bomaid.png',
	authPageLogoFallback: undefined as string | undefined,

	oneSignalAppId: 'b396cc59-a3a6-4f91-b1c2-a52a103cd312',
	environmentName: 'bomaid',
	production: true,
	apiProduction: true,
	showUatBuildBanner: false,
	includeFaceScanReportEmailMessage: true,

	countryCode: 'za',
	defaultMobileCountryCode: 'bw',
	organizationId: 'fe16fd64-3643-4f8f-ba1a-08dd93038382',
	scanFriendAllowed: false,
	pnExternalServicesBaseUrl: undefined as string | undefined,
	enableMobileRegistation: true,
	enableWebRegistation: true,

	enableExternalLogin: false,
	enableLocalAccounts: true,

	enableEnterpriseRegistration: true,

	iosAuthRedirect: 'not-defined',
	androidAuthRedirect: 'not-defined',

	whatsappEnabled: false,
	enableRewardsPartner: true,

	androidStoreLink: 'https://play.google.com/store/apps/details?id=com.alulatechnologies.vivascore.bomaid',
	iosStoreLink: 'https://apps.apple.com/app/id6753338030',
	              
	E2E_TEST_MODE: false, // Set to true when running E2E tests to enable mock API services

	defaultCulture: 'en-ZA',
	availablelanguages: [
		{ culture: 'en-ZA', text: 'English (South Africa)', dir: 'ltr' },
	],

};

